import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 · Página no encontrada | eien</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <main className="min-h-[70vh] bg-gray-50 dark:bg-[#0a0a0a] pt-32 pb-20 px-4 flex items-center">
        <section className="max-w-2xl mx-auto text-center">
          <p className="w-fit mx-auto text-[10px] font-medium uppercase tracking-[0.2em] text-[#11b36d] bg-[#11b36d]/10 border border-[#11b36d]/20 rounded-full px-3 py-1 mb-5">
            404
          </p>
          <h1 className="text-4xl md:text-5xl font-thin tracking-tight text-[#0b2b40] dark:text-white mb-4">
            Esta página no existe.
          </h1>
          <p className="text-slate-500 dark:text-slate-400 font-light mb-8">
            Podés volver al sitio o ir directo a los modelos de trabajo para seguir explorando.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/" className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#11b36d] text-white font-semibold hover:bg-[#0ea060] transition-colors">
              Volver al inicio
            </Link>
            <Link to="/modelos" className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-gray-200 dark:border-white/[0.12] text-slate-600 dark:text-slate-300 hover:border-[#11b36d]/50 hover:text-[#11b36d] transition-colors">
              Ver modelos
            </Link>
            <Link to="/capacidades" className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-gray-200 dark:border-white/[0.12] text-slate-600 dark:text-slate-300 hover:border-[#11b36d]/50 hover:text-[#11b36d] transition-colors">
              Ver capacidades
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}
